import './style.scss'
import Lightbox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
  name: 'GalleryWrapper',
  props: ['componentData'],
  computed: {
    images () {
      return this.componentData.filter(x => x.image && x.image.sizes).map((x) => {
        const y = {}
        y.thumb = x.image.sizes.friwi_med
        y.src = x.image.url
        return y
      })
    }
  },
  methods: {
    handleThumbClick (e, index) {
      // this.log('index: ', index)
      this.$refs.lightbox.showImage(index)
    }
  },
  render (h) {
    const { images } = this
    return (
      <div class='GalleryWrapper'>
        <ul class='GalleryWrapper__thumbs'>
          {images
            ? (images.map((i, index) => (
              <li
                class='GalleryWrapper__thumb'
                onClick={(e) => this.handleThumbClick(e, index)}
             >
              <div class='GalleryWrapper__thumb-inner'
                style={`background-image: url('${i.thumb}')`}
              />
             </li>
            )))
            : null
          }
        </ul>
        <Lightbox
          media={images}
          showLightBox={false}
          ref={'lightbox'}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/GalleryWrapper/index.js